module.exports = __webpack_public_path__ + "img/logo@3x_1.00705823.png";